import { createTask } from 'utils/apiWrapper';
import { Scene } from 'types/Scene';
import { MediaLayerTypeEnum, ScalingModeEnum, VideoFileContainerEnum } from 'api';

export const createCompressResolutionTask = async (
  toHeight: number,
  scene: Scene,
  userKey: string
) => {
  const width = Math.floor((toHeight / scene.size.height) * scene.size.width);
  return createTask(
    {
      scenes: [
        {
          layers: [
            {
              type: MediaLayerTypeEnum.Video,
              content: {
                url: scene.src,
                trimStart: scene.trimStart
              },
              transform: {
                scale_auto: ScalingModeEnum.Fit
              },
              timeEnd: scene.duration
            }
          ],
          effects: [],
          isMuted: false
        }
      ],
      audio: null,
      targetSettings: {
        width: width - (width % 2),
        height: toHeight,
        container: VideoFileContainerEnum.Mp4,
        effects: []
      }
    },
    userKey
  );
};
